import S from './DriversScoreWidgetStyles';
import EntityRating from '../common/EntityRating/EntityRating';
import { createCSV, downloadFile } from '../../utils/commonUtils';
import Icon from '../common/Icon/Icon';
import { IconKeys } from '../common/Icon/IconKeys';
import { DriverDetails } from '../../API/types/Drivers';
import { TimePeriod } from '../../constants/TimePeriod';

const PERIOD_TO_SCORE_FIELD: Record<string, 'score' | 'scoreDaily' | 'scoreWeekly' | 'scoreMonthly'> = {
  daily: 'scoreDaily',
  weekly: 'scoreWeekly',
  monthly: 'scoreMonthly',
};

type Props = Readonly<{
  fleetId: string;
  groupFilters?: Record<string, any>;
  reportName?: string;
  averageScore?: number | null;
  period?: string;
  allDrivers?: DriverDetails[];
}>;

function DriversScoreWidget({
  reportName, averageScore, period = 'all', allDrivers = [],
}: Props): JSX.Element {
  const scoreField = PERIOD_TO_SCORE_FIELD[period] ?? 'score';
  const scoreDisplay = averageScore != null ? Math.round(averageScore) : null;
  const periodLabel = (TimePeriod as any)[period] ?? TimePeriod.all;

  const withScore = allDrivers.filter((d) => {
    const s = d[scoreField] as number | null;
    return s != null && s > 0;
  });
  const sorted = [...withScore].sort((a, b) => {
    const sa = (a[scoreField] as number) ?? 0;
    const sb = (b[scoreField] as number) ?? 0;
    return sb - sa;
  });
  const topDrivers = sorted.slice(0, 3);
  const lowDrivers = [...sorted].reverse().slice(0, 3);

  return (
    <S.Wrapper>
      <button
        className="report-btn"
        title="Create report"
        type="button"
        onClick={() => {
          downloadFile(createCSV([...topDrivers, ...lowDrivers] as Record<string, any>[]), `${reportName}_widgets`, 'text/csv');
        }}
      >
        <Icon iconKey={IconKeys.SUMMARIZE} />
      </button>
      <EntityRating
        title={`Top driver scores • ${periodLabel}`}
        entities={topDrivers}
        ratingField={scoreField}
        entityType="driver"
        isLoading={false}
      />
      <div className="horizont-line" />
      <EntityRating
        title={`Lowest driver scores • ${periodLabel}`}
        entities={lowDrivers}
        ratingField={scoreField}
        entityType="driver"
        isLoading={false}
      />
      <div className={`average-score${scoreDisplay === null ? ' no-score' : ''}`}>
        <div className="title">Average drivers score</div>
        <div className="score">{scoreDisplay ?? 'N/A'}</div>
      </div>
    </S.Wrapper>
  );
}

export default DriversScoreWidget;
